import { render } from "./IndexIntervention.vue?vue&type=template&id=4c40b8b5&scoped=true"
import script from "./IndexIntervention.vue?vue&type=script&lang=js"
export * from "./IndexIntervention.vue?vue&type=script&lang=js"

import "./IndexIntervention.vue?vue&type=style&index=0&id=4c40b8b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c40b8b5"]])

export default __exports__